export default __webpack_public_path__ + "static/media/background.7117a48d.png";